const config_data = {
  api: '/dsi_aristi/api',
  baseURL:"https://aristiweb.decathlon.in",
  api1: 'https://aristiweb.decathlon.in/AristiAPIs',
  api2:'/api-server/dsi_aristi',
  api3:'/dsi_aristi',
  api4:'https://aristiweb.decathlon.in/api-server/dsi_aristi',
  years: [
    new Date().getFullYear() - 2,
    new Date().getFullYear() - 1,
    new Date().getFullYear(),
    new Date().getFullYear() + 1,
    new Date().getFullYear() + 2,
  ],
  month: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  menuItems: {
    Dashboard: { path: '#', icon: 'fa fa-dashboard' },
    'Global Dashboard - Retail': { path: '/dashboardRetail', icon: null },
    'Store Dashboard': { path: '/storeDashboardRetail', icon: null },
    'Global Dashboard - Logistics': { path: '/dashboardWareHouse', icon: null },
    'Warehouse Dashboard': { path: '/storeDashboardWareHouse', icon: null },
    'City Leader Dashboard': { path: '/cityleader', icon: null,},
    'Waste Management Dashboard' : { path: '/WasteManagementDashboard', icon: null },
    'Delivery Efficiency Dashboard': { path: '/DeliveryEfficiency', icon: null },
    Handover: { path: '/handovers', icon: 'fa fa-edit' },
    'View Images': { path: '/handovers/viewImages', icon: 'fa fa-edit' },
    Incident: { path: '/incidents', icon: 'fa fa-pencil' },
    "Evacuation Drill": { path: '/evacuations', icon: 'fa fa-building-o' },
    'Non Conformities': {
      path: '/nonconformities',
      icon: 'fa fa-check-square-o',
    },
    Training: { path: '/training', icon: 'fa fa-clone' },
    'Project Tracker': { path: '/projectTracker', icon: 'fa fa-book' },
    Project: { path: '/projectTracker/project', icon: 'fa fa-book' },
    'Purchase Order': {
      path: '/projectTracker/purchaseOrder',
      icon: 'fa fa-book',
    },

    TPV: { path: '/tpv', icon: "fa fa-industry" },

    Diagnosis: { path: '/diagnosis', icon: 'fa fa-file' },
    'Safety Register': { path: '/safetyregister', icon: 'fa fa-flag' },
    'Gate Pass': { path: '/gatePass', icon: 'fa fa-ticket' },
    Admin: { path: '#', icon: 'fa fa-user-circle' },
    'Add User': { path: '/adduser', icon: null },
    'Manage User Stores': { path: '/manageuserstores', icon: null },
    'Edit CheckList': { path: '/editChecklist', icon: null },
    'Edit Incident Email Config': {
      path: '/editIncidentEmailConfig',
      icon: null,
    },
    'FED ID Extract': {
      path: '/fedIdExtract',
      icon: null,
    },
    'Assets': { path: '/Assets', icon: "fa fa-cogs" },
    'Asset Category': { path: '/AssetCategories', icon: "fa fa-cogs" },
    'Identity Card': { path: '#', icon: "fa fa-dashboard" },
    'Store Identity Card': { path: '/Stores', icon: "fa fa-store" },
    'Warehouse Identity Card': { path: '/Warehouses', icon: "fa fa-store" },

    'Maintenance Request': { path: '#', icon: "fa fa-store" },
    'WorkOrder Store' : { path: '/WorkOrderStore', icon: "fa fa-store" },
    'WorkOrder Vendor' : { path: '/WorkOrderVendor', icon: "fa fa-store" },
    'Quotation Store' : { path: '/QuotationStore', icon: "fa fa-store" },
    'Quotation Vendor' : { path: '/QuotationVendor', icon: "fa fa-store" },
    
    'Vendors': { path: '/Vendors', icon: "fa fa-industry" },
    'PMP': { path: '#', icon: "fa fa-calendar" },
    'PMP - Vendor':{ path:'/PMPVendorList',icon:'fa fa-calendar'},
    'PMP - Store':{ path:'/PMPList',icon:'fa fa-calendar'},

    'Budget Planner': { path: '#', icon: "fa fa-calendar" },
    'Budget Category Master':{ path:'/BudgetCategoryMaster',icon:'fa fa-calendar'},
    'Budget Planner SOM':{ path:'/BudgetPlannerSOM',icon:'fa fa-calendar'},
    'Budget Planner Approval ZOMC':{ path:'/BudgetPlannerApprovalZOMC',icon:'fa fa-calendar'},
    'Budget Planner Approval Finance':{ path:'/BudgetPlannerApprovalFinance',icon:'fa fa-calendar'},
    
    'Asset Management': { path: '/PMP', icon: "fa fa-cogs" },
    'Vendor Management': { path: '#', icon: "fa fa-industry" },
    'Vendors Contract Mapping': { path: '/VendorContract', icon: "fa fa-industry" },

    'Auditors': { path: '/Auditor', icon: "fa fa-industry" },
    'Auditors Contract Mapping': { path: '/AuditorContract', icon: "fa fa-industry" },

    'Warehouse Leader Dashboard': { path: '/WarehouseLeader', icon: "fa fa-industry" },
    
    'Maintenance Dashboard': { path: '/MaintenanceDashboard', icon: "fa fa-industry" },
    'Stores Dashboard': { path: '/MaintenenceStoreDashBoard', icon: "fa fa-industry" },
    'Warehouses Dashboard': { path: '/MaintenenceWareHouseDashBoard', icon: "fa fa-industry" },
    
    'Payments': { path: '#', icon: "fa fa-industry" },
    'AMC Payment - Vendor': { path: '/PaymentInvoiceCreation', icon: "fa fa-industry" },
    'AMC Payment - SOM': { path: '/PaymentInvoiceProcessSOM', icon: "fa fa-industry" },


    
  },
};
// 
export const Config = [JSON.stringify(config_data)];
